import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Mic, ArrowRight } from "lucide-react";

/** Sticky mobile-only CTA that scrolls to the lead form. Hides while the form is on screen. */
export default function MobileCTA({ label = "Quiero mi VideoPodcast" }) {
  const [scrolled, setScrolled] = useState(false);
  const [formInView, setFormInView] = useState(false);
  const formRef = useRef(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    formRef.current = document.getElementById("solicitar-propuesta");
    let observer;
    if (formRef.current) {
      observer = new IntersectionObserver(
        ([entry]) => setFormInView(entry.isIntersecting),
        { threshold: 0.1 }
      );
      observer.observe(formRef.current);
    }

    return () => {
      window.removeEventListener("scroll", onScroll);
      observer?.disconnect();
    };
  }, []);

  const goToForm = () => {
    document.getElementById("solicitar-propuesta")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <AnimatePresence>
      {scrolled && !formInView && (
        <motion.div
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
          className="md:hidden fixed bottom-0 left-0 right-0 z-40 p-3 bg-white/85 backdrop-blur-md border-t border-slate-200"
          data-testid="mobile-cta-bar"
        >
          <button
            onClick={goToForm}
            className="w-full h-14 rounded-full bg-gradient-to-r from-galvani-blue to-galvani-purple text-white font-body font-semibold text-base shadow-lg shadow-blue-500/30 flex items-center justify-center gap-2 active:scale-[0.98] transition-transform"
            data-testid="mobile-cta-btn"
          >
            <Mic className="w-5 h-5" />
            {label}
            <ArrowRight className="w-4 h-4" />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
